import { Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { CrudService } from '../service/crud.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ECRService } from '../service/ecr.service';

@Component({
  selector: 'app-view-thr-reportee',
  templateUrl: './view-thr-reportee.component.html',
  styleUrls: ['./view-thr-reportee.component.css']
})
export class ViewThrReporteeComponent implements OnInit {
  UserName: any;
  Reportees: any;
  IsHRAdmin: any;
  initialUserName = '';
  Reporte: any = [];

  reporteeData: any = [];

  managerData: any = [];
  tmcManager: any = '';
  tmc: any = '';
  year: any = '2024';
  month: number = new Date().getMonth() + 1;

  userEmail: any = '';


  constructor(private _ecrService: ECRService, private _crudService: CrudService, private router: Router, private spinner: NgxSpinnerService, private _sharedSer: SharedService) {
    this.userEmail = localStorage.getItem("UserEmail");
    this.UserName = localStorage.getItem("Full_Name");
    this.tmc = localStorage.getItem("TMC");
  }

  ngOnInit() {
    this.getTHRReporteeECR(this.tmcManager);
    this.getECRManagerData(this.userEmail);
  }
  shortName(full_name: any) {
    let arr = full_name.split(' ');
    let ans = '';
    for (var i = 0; i < arr.length; i++) {
      let ans1 = arr[i].split('');
      ans = ans + ans1[0];
      ans = ans.replace('undefined', '');
    }
    return ans.toUpperCase();
  }

  getTHRReporteeECR(tmcManager: any) {
    let fd = new FormData()
    fd.append('tmc', tmcManager)
    this._crudService.post(`Master/GetTHRReportee`, fd).subscribe((x: any) => {
      console.log(x);
      for (var i = 0; i < x.Data.length; i++) {
        this.getECRData(x.Data[i])
      }

    })
  }

  getECRData(x: any) {
    this.reporteeData = [];
    this._ecrService.GetReporteeECR(x.THR_EMAIL_ID, this.month, this.year).subscribe((d: any) => {
      console.log(d);
      if (d.Data.length) {
        this.reporteeData.push({ name: x.THR_EMPLOYEE_NAME, tmc: x.THR_TMC, CountofFilledECR: d.Data[0].CountofFilledECR, WorkingDay: d.Data[0].WorkingDay })
      }
      else {
        this.reporteeData.push({ name: x.THR_EMPLOYEE_NAME, tmc: x.THR_TMC, CountofFilledECR: 0, WorkingDay: 0 })
      }
      //return d;
    })
  }

  getECRManagerData(tmc: any) {
    this._ecrService.GetReporteeECR(tmc, this.month, this.year).subscribe((d: any) => {
      this.managerData = d.Data[0];
    })
  }

  submit() {
    this.getTHRReporteeECR(this.userEmail);
    this.getECRManagerData(this.userEmail);
  }

}
